import {Box, Text, tempo} from '@tempo/core';
import {NavLink} from './Navlink';
import type {NavLinkProps} from './Navlink';

const BaseTextWithLink = tempo(Text);

const textWithLinkDefaults = {
	textAlign: 'center' as const,
	variant: 'caption.strong',
	fontWeight: '400',
	opacity: '0.9',
	color: 'text.neutral.secondary.default',
	sx: {
		a: {
			textDecoration: 'underline',
		},
		'a:hover': {
			color: 'text.accent.primary.hovered',
		},
	},
};

export const TextWithLink: typeof BaseTextWithLink = (props) => (
	<BaseTextWithLink {...textWithLinkDefaults} {...props} />
);

export const TextWithNavLink: React.FC<NavLinkProps & {text: string}> = ({
	text,
	...props
}) => {
	return (
		<Box textAlign={props.textAlign ?? 'center'}>
			<Text
				display="inline"
				fontSize="sm"
				color="text.neutral.secondary.default"
			>
				{text}
			</Text>{' '}
			<NavLink display="inline" p="0" fontSize="sm" {...props} />
		</Box>
	);
};
